export default __webpack_public_path__ + "static/media/l.416eea4a.jpg";